import React from 'react';
import { View } from 'react-native';

import defaultStyles from './ItemDivider.jss';

const ItemDivider = (): React.ReactElement => <View style={defaultStyles.itemContainer} />;

export default ItemDivider;
